import React, { ReactNode, useContext } from 'react';
import AppCtxBo from './AppCtxBo';

// *** App Context Type
type AppContextType = {
    appCtxBo: AppCtxBo,
    setAppCtxBo: (prevState: AppCtxBo) => void
    // dispatch: React.Dispatch<any>
}

// *** init Object
const ignoreValue: AppContextType = {
    appCtxBo: new AppCtxBo(),
    setAppCtxBo: prevState => { }
}

// *** App Context
const AppCtx = React.createContext<AppContextType>(ignoreValue);

// *** App Context Provider
export const AppCtxProvider: React.FC<{children:ReactNode, abTestVersion?:string}> = ({ children, abTestVersion }) => {
    // ***************************
    // App Context state
    // ***************************
    // Unterschied useReducer und useState: 
    // useReducer bietet mit der reducer Funktion (siehe oben) die Basis an, um ein neues Objekt zu erzeugen.
    // Erst wenn ein neues Objet erzeugt wurde, werden die abhängigen React Komponenten neu gerendert.
    // const [appState, dispatch] = React.useReducer(AppContextReducer, new AppStateBo());
    const [appState, setAppState] = React.useState(new AppCtxBo(abTestVersion));

    const setAppStateClone = (bo: AppCtxBo) => {
        setAppState({ ...bo });
    }

    return <AppCtx.Provider value={{ appCtxBo: appState, setAppCtxBo: setAppStateClone }}>{children}</AppCtx.Provider>
}

const useAppCtx = () => {
    return useContext(AppCtx);
}

export default useAppCtx;